import React, { useState } from 'react';

const Instructions = () => {
  const [showInstructions, setShowInstructions] = useState(true);

  if (!showInstructions) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.9)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      color: 'white',
      fontFamily: 'Courier New, monospace'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, rgba(0, 255, 255, 0.1), rgba(255, 0, 128, 0.1))',
        padding: '40px',
        borderRadius: '15px',
        border: '2px solid rgba(0, 255, 255, 0.3)',
        maxWidth: '500px',
        textAlign: 'center'
      }}>
        <h1 style={{ color: '#00ffff', marginBottom: '20px' }}>
          🌌 Cosmic Audio Visualizer
        </h1>
        <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>
          Professional EDM visualization with real-time spectrum analysis and physics-based camera movement.
        </p>
        <div style={{ marginBottom: '30px', fontSize: '14px', opacity: 0.8 }}>
          <p>• Click "Start Audio" and allow microphone access</p>
          <p>• Switch camera modes with the top-right button</p>
          <p>• Play music for the best experience!</p>
        </div>
        <button
          onClick={() => setShowInstructions(false)}
          style={{
            background: 'linear-gradient(45deg, #00ffff, #ff0080)',
            border: 'none',
            padding: '15px 30px',
            borderRadius: '25px',
            color: 'white',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '16px',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}
        >
          Enter the Cosmos
        </button>
      </div>
    </div>
  );
};

export default Instructions;